module.exports = __webpack_public_path__ + "img/161679bddb6e523f1ecbc0ed4612f16c.png";